import { createPinia } from 'pinia'
import { App } from 'vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import persistConfig from './persist'

// 创建pinia实例
const pinia = createPinia()

// 使用持久化插件
pinia.use(piniaPluginPersistedstate)

/**
 * 导出初始化pinia的函数
 * 在main.ts中使用
 */
export function setupPinia(app: App<Element>) {
  app.use(pinia)
}

// 导出持久化配置
export { persistConfig }

export default pinia